import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import { Badge } from '@/components/ui/badge';
import { Search, Building2 } from 'lucide-react';
import type { Property } from '@/lib/types/temp-types';

interface PropertyListProps {
  properties: Property[];
  onPropertyClick: (property: Property) => void;
}

export function PropertyList({ properties, onPropertyClick }: PropertyListProps) {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Properties</CardTitle>
        <div className="relative">
          <Search className="absolute left-3 top-3 h-4 w-4 text-muted-foreground" />
          <Input
            placeholder="Search properties..."
            className="pl-9"
          />
        </div>
      </CardHeader>
      <CardContent>
        <div className="grid gap-4">
          {properties.map((property) => (
            <div
              key={property.id}
              onClick={() => onPropertyClick(property)}
              className="flex items-center gap-4 p-4 rounded-lg border cursor-pointer hover:bg-muted/50 transition-colors"
            >
              <div className="p-2 bg-primary/10 rounded-full">
                <Building2 className="h-6 w-6 text-primary" />
              </div>
              <div className="flex-1">
                <div className="flex items-center gap-2">
                  <h3 className="font-medium">{property.name}</h3>
                  <Badge variant={property.status === 'active' ? 'default' : 'secondary'}>
                    {property.status}
                  </Badge>
                </div>
                <p className="text-sm text-muted-foreground">{property.address}</p>
              </div>
              <div className="text-right">
                <div className="text-sm font-medium">
                  {property.size.toLocaleString()} sq.ft.
                </div>
                <p className="text-sm text-muted-foreground">
                  {property.type}
                  {property.units && ` • ${property.units} units`}
                </p>
              </div>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
}